import React from 'react';
import { DefaultLink } from "../components/Button/DefaultLink/DefaultLink";
export var defaultLinkContext = DefaultLink;
export var LinkContext = /*#__PURE__*/React.createContext(defaultLinkContext);